<template>
    <div class="confirm-content">
        <result-message
            v-if="checkCancel || testInputScheduleItem.checkCancel"
            type="error"
            title="Không thể hủy lịch khi đã tới giờ test!"
        />

        <result-message
            v-else-if="checkConfirm || testInputScheduleItem.checkConfirm"
            type="error"
            title="Ca test đã hết hiệu lực xác nhận!"
        />

        <div v-else>
            <p>
                Bạn có 01 lịch hẹn test speaking của khách hàng
                <span class="confirm-content__strong">{{ item.phone }} - {{ item.name }}</span>.
            </p>
            <p>
                Vào lúc
                <span class="confirm-content__strong">{{ testInputScheduleItem.schedule }}</span>.
            </p>
            <p>Vui lòng xác nhận nếu đã chắc chắn tình trạng của khách hàng.</p>

            <div class="confirm-content__actions">
                <button
                    type="button"
                    class="confirm-content__button confirm-content__button--outline"
                    @click="confirm(false)"
                >
                    Hủy lịch
                </button>
                <button
                    type="button"
                    class="confirm-content__button confirm-content__button--primary"
                    @click="confirm(true)"
                >
                    Xác nhận tham gia
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

import ResultMessage from "./ResultMessage.vue";

export default {
    name: "ContentConfirm",
    components: { ResultMessage },
    props: {
        item: {
            type: Object,
            required: true,
        },
        testInputScheduleItem: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            checkCancel: false,
            checkConfirm: false,
        };
    },
    methods: {
        confirm(value) {
            const now = moment();
            const schedule = moment(this.testInputScheduleItem.schedule, "HH:mm DD-MM-YYYY");

            if (now > schedule && !value) {
                this.checkCancel = true;
                return;
            }

            if (schedule.diff(now, "hours") < 1) {
                this.checkConfirm = true;
                return;
            }

            this.$emit("confirm", this.testInputScheduleItem.id, value);
        },
    },
};
</script>

<style scoped>
.confirm-content {
    color: #374151;
    font-size: 15px;
    line-height: 1.55;
}

.confirm-content p {
    margin: 0 0 16px;
}

.confirm-content__strong {
    font-weight: 700;
}

.confirm-content__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 32px;
}

.confirm-content__button {
    border-radius: 999px;
    padding: 9px 16px;
    font-weight: 600;
    transition: background 0.2s ease, opacity 0.2s ease;
}

.confirm-content__button--outline {
    border: 2px solid #78716c;
    background: #ffffff;
    color: #57534e;
}

.confirm-content__button--outline:hover {
    background: #f5f5f4;
}

.confirm-content__button--primary {
    border: 2px solid #65558f;
    background: #65558f;
    color: #ffffff;
}

.confirm-content__button--primary:hover {
    opacity: 0.9;
}

@media (max-width: 575px) {
    .confirm-content__actions {
        flex-direction: column;
    }
}
</style>